var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraUploadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#C7222A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.5H19L21 14.5H27L29 16.5H32C32.5304 16.5 33.0391 16.7107 33.4142 17.0858C33.7893 17.4609 34 17.9696 34 18.5V30.5C34 31.0304 33.7893 31.5391 33.4142 31.9142C33.0391 32.2893 32.5304 32.5 32 32.5H16C15.4696 32.5 14.9609 32.2893 14.5858 31.9142C14.2107 31.5391 14 31.0304 14 30.5V18.5C14 17.9696 14.2107 17.4609 14.5858 17.0858C14.9609 16.7107 15.4696 16.5 16 16.5ZM24 19.5C22.6739 19.5 21.4021 20.0268 20.4645 20.9645C19.5268 21.9021 19 23.1739 19 24.5C19 25.8261 19.5268 27.0979 20.4645 28.0355C21.4021 28.9732 22.6739 29.5 24 29.5C25.3261 29.5 26.5979 28.9732 27.5355 28.0355C28.4732 27.0979 29 25.8261 29 24.5C29 23.1739 28.4732 21.9021 27.5355 20.9645C26.5979 20.0268 25.3261 19.5 24 19.5ZM24 21.5C24.7956 21.5 25.5587 21.8161 26.1213 22.3787C26.6839 22.9413 27 23.7044 27 24.5C27 25.2956 26.6839 26.0587 26.1213 26.6213C25.5587 27.1839 24.7956 27.5 24 27.5C23.2044 27.5 22.4413 27.1839 21.8787 26.6213C21.3161 26.0587 21 25.2956 21 24.5C21 23.7044 21.3161 22.9413 21.8787 22.3787C22.4413 21.8161 23.2044 21.5 24 21.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraUploadIcon);
export default __webpack_public_path__ + "static/media/camera-upload-icon.add678272ed14172a23fd0abfee076ea.svg";
export { ForwardRef as ReactComponent };